import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';
import RoleInput from '../../shared/input/RoleInput';

const UserCreateForm = ({ onSubmit, initUser = {}, loading, roles }) => {
  const methods = useForm({ defaultValues: initUser });
  return (
    <FormProvider {...methods}>
      <form id="user-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Логін"
          type="input"
          name="userName"
          autoFocus="true"
          disabled={loading}
          placeholder={'Введіть логін'}
          validation={notBlankValidation}
        />
        <Input
          label="Пароль"
          type="input"
          name="password"
          disabled={loading}
          placeholder={'Введіть пароль'}
          validation={notBlankValidation}
        />
        <Input
          label="Ім'я"
          type="input"
          name="firstName"
          disabled={loading}
          placeholder={"Введіть ім'я"}
          validation={notBlankValidation}
        />
        <Input
          label="Прізвище"
          type="input"
          name="lastName"
          disabled={loading}
          placeholder={'Введіть прізвище'}
          validation={notBlankValidation}
        />
        <RoleInput roles={roles} loading={loading} />
      </form>
    </FormProvider>
  );
};

export default UserCreateForm;
